import { Vue, Component, Prop } from "vue-property-decorator";

import moment from "moment";

import SubscriptionStatusBadge from "@/components/subscriptionStatusBadge/subscriptionStatusBadge";

import {
  isOrderInTerminalStatus,
  orderStatusToSpanishLabel,
  isDeliveryAvailable,
} from "@/plugins/subscriptions_helper";
import { Getter } from "vuex-class";

@Component({
  components: { SubscriptionStatusBadge },
})
export default class OrderPreviewHeader extends Vue {
  @Prop({ default: null }) order;

  @Getter getCurrentOrder;
  @Getter getIsUnderMobile;
  @Getter getSubscription;

  get isLastOrder() {
    return this.order.json_products;
  }

  get orderDealDate() {
    const { programmed_for, deal_date } = this.order;
    if (this.isLastOrder) return programmed_for;
    return deal_date;
  }

  get orderDealDateDayLabel() {
    return moment(this.orderDealDate).format("ddd").toLocaleUpperCase().replace(".", "");
  }

  get orderDealDateMonthLabel() {
    return moment(this.orderDealDate).format("MMM").toLocaleUpperCase().replace(".", "");
  }

  get isLastOrderInTerminalStatus() {
    if (this.getCurrentOrder) {
      return isOrderInTerminalStatus(this.getCurrentOrder);
    }
    return true;
  }

  get orderStatusLabel() {
    const { status, deadline_update_date, programmed_for } = this.order;
    const { auto_generate_orders, deal_date } = this.getSubscription;
    if (!this.isLastOrder) {
      if (this.isLastOrderInTerminalStatus) {
        if (auto_generate_orders) {
          return {
            label: `Edita tu menú hasta el ${moment(deadline_update_date).format(
              "ddd DD MMM hh:mm A"
            )}`,
            color: "orange",
          };
        }
        return {
          label: `Confirma antes del ${moment(deadline_update_date).format("ddd DD MMM hh:mm A")}`,
          color: "orange",
        };
      } else if (!isDeliveryAvailable(this.getSubscription)) {
        return {
          label: "Entregas no disponibles luego del 27 de julio.",
          color: "black",
        };
      } else {
        return {
          label: `Personaliza tu pedido como prefieras. Podrás confirmarlo a partir del ${moment(
            deal_date
          ).format("dddd DD [de] MMMM")}.`,
          color: "black",
        };
      }
    } else {
      const dealDate = moment(programmed_for).format("DD [de] MMM");
      return orderStatusToSpanishLabel(status, dealDate);
    }
  }
}
